<template>
  <div>
    <v-row class="px-3 py-1">
      <v-col
        cols="12"
        class="pa-1 d-flex justify-space-between align-center"
      >
        <span class="d-flex align-center lighterGray--text">
          {{ title }}
          <v-icon
            v-if="titleIcon"
            class="ml-2"
          >
            {{ titleIcon }}
          </v-icon>
        </span>

        <v-btn
          v-if="showAction"
          class="pa-0 text-center no-bg-hover mr-1"
          style="
            text-transform: inherit;
            color: #FF3232;
            min-width: 60px;
            "
          text
          :ripple="false"
          @click="() => $emit('action')"
        >
          {{ actionText }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row
      v-if="!data.length"
      class="pa-1"
    >
      <v-col
        cols="12"
        class="py-2 px-3 d-flex justify-space-between align-center lighterGray--text"
      >
        {{ noDataText }}
      </v-col>
    </v-row>

    <v-row
      v-for="(item, index) in data"
      v-else
      :key="index"
      class="pa-1"
      :class="{'b-bottom': index !== data.length - 1}"
    >
      <v-col
        cols="12"
        class="py-2 px-3 d-flex justify-space-between align-center"
      >
        <div class="d-flex">
          <v-avatar
            color="#333333"
            :class="item.logo ? 'avatar-group' : 'avatar-group white--text'"
            size="50"
          >
            <v-img
              v-if="item.logo"
              :src="item.logo"
            ></v-img>
            <span
              v-else
              class="font-weight-medium"
            >{{ avatarText(item.name) }}</span>
          </v-avatar>
          <div class="d-flex flex-column ml-2 justify-center">
            <span class="white--text">{{ item.name }}</span>
          </div>
        </div>
        <span class="text-xs"></span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
import { computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'

export default {
  name: 'GroupList',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    titleIcon: {
      type: String,
      default: '',
    },
    showAction: {
      type: Boolean,
      default: false,
    },
    actionText: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
      required: true,
    },
    noDataText: {
      type: String,
      default: 'No data.',
    },
  },
  setup(props) {
    const computedTitle = computed(() => props.title)

    return {
      // computed
      computedTitle,

      avatarText,
    }
  },
}
</script>

<style lang="scss" scoped>
.avatar-group {
  // border-radius: 8px;
  border: 1px solid #555555;
  border-style: dashed;
}
</style>
